import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { contactService } from '../../../../../shared/services/apiService'

/// Images
import avatar1 from '../../../images/avatar/1.jpg'
import avatar2 from '../../../images/avatar/2.jpg'
import avatar3 from '../../../images/avatar/3.jpg'
import avatar4 from '../../../images/avatar/4.jpg'
import avatar5 from '../../../images/avatar/5.jpg'
import MsgBox from './MsgBox'

const Chat = ({ PerfectScrollbar, toggleChatBox, toggleTab }) => {
  const [openMsg, setOpenMsg] = useState(false)
  const [selectedMessage, setSelectedMessage] = useState(null)
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(true)

  // Fetch contact messages
  useEffect(() => {
    const fetchMessages = async () => {
      setLoading(true)
      try {
        const response = await contactService.getMessages({ per_page: 50, page: 1 })
        if (response.data && response.data.data) {
          setMessages(response.data.data)
        }
      } catch (error) {
        console.error('Error fetching messages:', error)
        setMessages([])
      } finally {
        setLoading(false)
      }
    }

    if (toggleTab === 'chat') {
      fetchMessages()
    }
  }, [toggleTab])

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    const now = new Date()
    const diff = Math.floor((now - date) / 1000)

    if (diff < 60) return 'À l\'instant'
    if (diff < 3600) return `Il y a ${Math.floor(diff / 60)} min`
    if (diff < 86400) return `Il y a ${Math.floor(diff / 3600)}h`
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' })
  }

  // Get initials from name
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2)
  }

  // Handle message click
  const handleMessageClick = (message) => {
    setSelectedMessage(message)
    setOpenMsg(true)
  }

  return (
    <div
      className={`tab-pane fade  ${toggleTab === 'chat' ? 'active show' : ''}`}
      id='chat'
      role='tabpanel'
    >
      <div
        className={`card mb-sm-3 mb-md-0 contacts_card dlab-chat-user-box ${
          openMsg ? 'd-none' : ''
        }`}
      >
        <div className='card-header chat-list-header text-center'>
          <Link to='#'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              width='18px'
              height='18px'
              viewBox='0 0 24 24'
              version='1.1'
            >
              <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <rect
                  fill='#000000'
                  x='4'
                  y='11'
                  width='16'
                  height='2'
                  rx='1'
                />
                <rect
                  fill='#000000'
                  opacity='0.3'
                  transform='translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) '
                  x='4'
                  y='11'
                  width='16'
                  height='2'
                  rx='1'
                />
              </g>
            </svg>
          </Link>
          <div>
            <h6 className='mb-1'>Messages de Contact</h6>
            <p className='mb-0'>{messages.length} message{messages.length > 1 ? 's' : ''}</p>
          </div>
          <Link to='#'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              width='18px'
              height='18px'
              viewBox='0 0 24 24'
              version='1.1'
            >
              <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <rect x='0' y='0' width='24' height='24' />
                <circle fill='#000000' cx='5' cy='12' r='2' />
                <circle fill='#000000' cx='12' cy='12' r='2' />
                <circle fill='#000000' cx='19' cy='12' r='2' />
              </g>
            </svg>
          </Link>
        </div>
        <PerfectScrollbar
          className={`card-body contacts_body p-0 dlab-scroll  ${
            toggleChatBox ? 'ps ps--active-y' : ''
          }`}
          id='DZ_W_Contacts_Body'
        >
          <ul className='contacts'>
            {loading ? (
              <li className='text-center py-4'>
                <div className='spinner-border text-primary' role='status'>
                  <span className='visually-hidden'>Chargement...</span>
                </div>
              </li>
            ) : messages.length > 0 ? (
              messages.map((message, index) => (
                <li
                  key={message.id}
                  className={`dlab-chat-user ${index === 0 ? 'active' : ''}`}
                  onClick={() => handleMessageClick(message)}
                >
                  <div className='d-flex bd-highlight'>
                    <div className='img_cont'>
                      <div className='rounded-circle user_img d-flex align-items-center justify-content-center' 
                           style={{background: message.status === 'new' ? '#007A33' : '#6c757d', color: '#fff', fontWeight: 'bold'}}>
                        {getInitials(message.name)}
                      </div>
                      <span className={`online_icon ${message.status === 'new' ? '' : 'offline'}`}></span>
                    </div>
                    <div className='user_info'>
                      <span>{message.name}</span>
                      <p>{message.subject.substring(0, 30)}{message.subject.length > 30 ? '...' : ''}</p>
                      <small className='text-muted'>{formatDate(message.created_at)}</small>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li className='text-center py-4'>
                <p className='text-muted'>Aucun message</p>
              </li>
            )}
          </ul>
        </PerfectScrollbar>
      </div>
      <MsgBox
        avatar1={avatar1}
        avatar2={avatar2}
        openMsg={openMsg}
        PerfectScrollbar={PerfectScrollbar}
        offMsg={() => setOpenMsg(false)}
        message={selectedMessage}
      />
    </div>
  )
}

export default Chat
